import {
  DocumentIssueDateTooltipImages,
  DocumentIssuedByTooltipImages,
  DocumentIssueEndDateTooltipImages,
  DocumentNumberTooltipImages,
  DocumentSeriesTooltipImages,
} from '@/features/selectors';

export const DocumentTooltip = () => {
  const getDocumentNumberTooltipImage = (documentId) => {
    return DocumentNumberTooltipImages[documentId] || DocumentNumberTooltipImages['DOCUMENT_PASSPORT'];
  };

  const getDocumentSeriesTooltipImage = (documentId) => {
    return DocumentSeriesTooltipImages[documentId] || DocumentSeriesTooltipImages['DOCUMENT_PASSPORT'];
  };

  const getDocumentIssueDateTooltipImage = (documentId) => {
    return DocumentIssueDateTooltipImages[documentId] || DocumentIssueDateTooltipImages['DOCUMENT_PASSPORT'];
  };

  const getDocumentIssueEndDateTooltipImage = (documentId) => {
    return DocumentIssueEndDateTooltipImages[documentId] || DocumentIssueDateTooltipImages[documentId] || DocumentIssueEndDateTooltipImages['DOCUMENT_PASSPORT'];
  };

  const getDocumentIssuedByTooltipImage = (documentId) => {
    return DocumentIssuedByTooltipImages[documentId] || DocumentIssuedByTooltipImages['DOCUMENT_PASSPORT'];
  };

  return {
    getDocumentNumberTooltipImage,
    getDocumentSeriesTooltipImage,
    getDocumentIssueDateTooltipImage,
    getDocumentIssueEndDateTooltipImage,
    getDocumentIssuedByTooltipImage,
  };
};
